export default __webpack_public_path__ + "static/Art_of_bicycle_trips_Final_logo2-06a88ab3f31618d868863a9d87f7e6ce.png";